import { render } from "./Calculator.vue?vue&type=template&id=1cf90315&bindings={\"currentNum\":\"setup\",\"pressed\":\"setup\",\"selectedOperation\":\"setup\",\"prevNum\":\"setup\"}"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"
script.render = render

export default script